import { render, staticRenderFns } from "./Rosco.vue?vue&type=template&id=271b2fc4&scoped=true&"
import script from "./Rosco.vue?vue&type=script&lang=js&"
export * from "./Rosco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271b2fc4",
  null
  
)

export default component.exports